import React from "react";
import { Route, Routes } from "react-router-dom";
import SalesOverview from "../Pages/SalesOverview";
import Company from "../Pages/Company";
import Header from "../Pages/LandingPage/Header";
import CreateNewAccount from "../Pages/SalesOverview/CreateNewAccount";
import ReviewAccount from "../Pages/SalesOverview/ReviewAccount";
import EditAccount from "../Pages/SalesOverview/EditAccount";
import AddCompany from "../Pages/Company/AddCompany";
import ReviewCompany from "../Pages/Company/ReviewCompany";
import EditCompany from "../Pages/Company/EditCompany";

const Routing = () => {
  return (
    <Routes>
      <Route element={<Header />}>
        <Route path="/sales-overview" element={<SalesOverview />} />
        <Route path="/company" element={<Company />} />
        <Route path="/create-account" element={<CreateNewAccount />} />
        <Route path="/review-account/:id" element={<ReviewAccount />} />
        <Route path="/edit-account/:id" element={<EditAccount />} />
        <Route path="/create-company" element={<AddCompany/>} />
        <Route path="/review-company/:id" element={<ReviewCompany/>} />
        <Route path="/edit-company/:id" element={<EditCompany/>} />
      </Route>
    </Routes>
  );
};

export default Routing;
